import { z } from 'zod/v4-mini';

import { DeviceType, deviceTypeSchema } from '@/models/MedicalDeviceModel.ts';
import { Schema, cz } from '@/utils/zodUtils.ts';

export const reportCategorySchema = z.literal([
  'severe_hypoglycemia',
  'perceived_hypoglycemia',
  'perceived_hyperglycemia',
  'tech_alert',
  'other',
]);

export type ReportCategory = z.infer<typeof reportCategorySchema>;

export type Report = {
  id: string;
  patientId: string;
  date: string;
  deviceId?: string;
  deviceType?: DeviceType;

  category: ReportCategory;
  message?: string;
};

export const reportSchema: Schema<Report> = cz.camelCaseObject({
  id: cz.id(),
  patient_id: z.string(),
  date: cz.datetime(),
  device_id: cz.optional(cz.id()),
  device_type: cz.optional(deviceTypeSchema),
  category: reportCategorySchema,
  message: cz.optional(z.string()),
});

export const getReportCategoryTranslation = (
  category: ReportCategory,
): string => {
  switch (category) {
    case 'severe_hypoglycemia':
      return 'models.reportCategory.severeHypoglycemia';
    case 'perceived_hypoglycemia':
      return 'models.reportCategory.perceivedHypoglycemia';
    case 'perceived_hyperglycemia':
      return 'models.reportCategory.perceivedHyperglycemia';
    case 'tech_alert':
      return 'models.reportCategory.techAlert';
    case 'other':
      return 'models.reportCategory.other';
  }
};
